import React from "react";
import Modal from 'react-modal';
import { Button } from "@material-ui/core";

import SocialButton from "./../../components/SocialButton";
import StorageService from "../../services/StorageService";
import { withRouter } from "react-router";
import ApiService from "../../services/ApiService";
import AuthenticationService from "../../services/AuthenticationService";
import { Constants } from "../../config";
import {AiOutlineClose} from 'react-icons/ai'

const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      width: '80%',
      transform: 'translate(-50%, -50%)',
      // height:'250px',
    },
  };


  
  class ModalBox extends React.Component {

    componentDidMount(){
      let params = new URLSearchParams(window.location.search);
  
      ApiService.getData('getCapaign', {slug:StorageService.getData("campaign_name") ? StorageService.getData("campaign_name") : params.get("campaign_name")}, false).then((response) => {
        if(!!response.data){
          if(response.data[0]?.image_console_id !=undefined) {
            StorageService.storeData('fr_event_id',response.data[0]?.image_console_id);
          }
          this.setState({capaignDetails:response.data[0]})
        }
      })
    }

    constructor(props) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let event_name = params.get("event_name");
      let campaign_name =  StorageService.getData("campaign_name") ? StorageService.getData("campaign_name") : params.get("campaign_name");
      let app_type = StorageService.getData("app_type") ? StorageService.getData("app_type") : params.get("app_type");
      let event_url = params.get("event");
  
      super(props);
  
    
      AuthenticationService.isCampaignActive(campaign_name, event_name);
  
      // AuthenticationService.isCampaignActive(
      //   this.props.match.params["campaign_name"],
      //   this.props.match.params["event_name"]
      // );
  
      this.state = {
        capaignDetails:{},
        // event_logo: StorageService.getData("event_logo")
        //   ? StorageService.getData("event_logo")
        //   : "",
        event_logo:'https://admin.eventforce.ai/assets/img/velo-logo.png',
        isLoading: false,
      };
  
      this.getEventDetailsByFriendlyURL(
        app_type == "photo-app" ? event_url : event_name
      );
    }


     // Google Login
  handleGoogleLogin = (user) => {
    let userDetails = {
      firstName: user._profile.firstName,
      lastName: user._profile.lastName,
      email: user._profile.email,
      id: user._profile.id,
    };
    this.callLoginApi(user._token.accessToken, userDetails, "google");
  };

  handleGoogleLoginFailure = (err) => {
    console.error(err);
  };

  callLoginApi(token, userDetails, type) {
 
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let event = params.get("event");
    let event_name = params.get("event_name");
    let campaign_name =  StorageService.getData("campaign_name") ? StorageService.getData("campaign_name") : params.get("campaign_name");
    let app_type = StorageService.getData("app_type") ? StorageService.getData("app_type") : params.get("app_type");
 
    let postParams = {
      token: token,
    };

    let apiPath = "";

    if (type === "google") apiPath = "googleLogin";
    else apiPath = "facebookLogin";

    ApiService.postData(apiPath, postParams, false).then((response) => {
    
      if (response.status == "success") {

        let {data} = response;
        let userData ={
          ...userDetails,
          ...data.user,
        };
 
        StorageService.storeData("access_token", response.token);
        StorageService.storeData("user_details", JSON.stringify(userData));
        let guestImage = StorageService.getData("guest_image");
      

        if(guestImage){ //Save Guest Image
          let newData = {
            ...userData,
            profile_image:guestImage,
        };
        StorageService.storeData("user_details", JSON.stringify(newData));

          let postParams = {
            profile_image:guestImage,
        };
          ApiService.postData("updateProfileImage", postParams, true).then(
            (response) => {                    
            }).catch(e=>{
                this.setState({isLoading:false});
            })
    }

        

        // console.log('Login Response', response);
      //For feature conference  -end
      // console.log('CampaignDetails', this.state.capaignDetails); return;
      
        if(this.state.capaignDetails?.type ==3){

          //For feature conference 
        if(!response.data.profilecompletion){
          this.props.history.push("/" + event_name + "/" + campaign_name + "/complete-profile");
          return;
        }

          this.props.history.push(
            "/" + event_name + "/" + campaign_name + "/speakers"
          );
          return;
        }

        if(this.state.capaignDetails?.type ==4){
          this.props.history.push("/find-your-photo?app_type=photo-app");
          return;

        }
       
        if (app_type == "photo-app") {
          if (event && event != "")
            this.props.history.push(
              "/find-your-photo?app_type=" + app_type + "&event=" + event
            );
          else this.props.history.push("/find-your-photo?app_type=" + app_type);
        } else{
          this.props.history.push(
            "/" + event_name + "/" + campaign_name + "/home"
          );
        }
      } else {
        console.log('Final Else ');

     
      }
    });
  }

  getEventDetailsByFriendlyURL(event_url) {
    if (event_url && event_url != null && event_url != "") {
      setTimeout(() => {
        this.setState({
          isLoading: true,
        });
      }, 10);

      let params = {
        event_url: event_url,
      };
      ApiService.getData("getByEventFriendlyName", params, true).then(
        (response) => {
          if (response.status == "success") {
            this.setState({ event_logo: response.data[0].logo });
            StorageService.storeData("event_logo", response.data[0].logo);
            StorageService.storeData("event_title", response.data[0].title);
            setTimeout(() => {
              this.setState({ isLoading: false });
            }, 1000);
          } else {
            this.setState({ isLoading: false });
            this.setState({
              event_logo: Constants.APP_LOGO,
            });
            StorageService.storeData("event_logo", Constants.APP_LOGO);
            StorageService.storeData("event_title", "Eventforce");
          }
        }
      );
    } else {
      this.setState({
        event_logo: Constants.APP_LOGO,
      });
      StorageService.storeData("event_logo", Constants.APP_LOGO);
      StorageService.storeData("event_title", "Eventforce");
      this.setState({
        isLoading: false,
      });
    }
  }

    render(){
      return(
        <Modal
          isOpen={this.props.isOpen}       
          contentLabel="Example Modal"
          style={customStyles}
      >      
      <div style={{justifyContent:'space-between',display:'flex'}}>

      <h6>Login To Continue</h6>
        <AiOutlineClose size={20} onClick={()=>{this.props.onClose()}}/>
      </div>

      <div style={{justifyContent:'center',display:'flex'}}>

      <SocialButton
              className="googleBtn socialBtn"
              provider="google"
              //appId="513730001544-bokue06vc3dnnvi01frkao7fp6n8j0fo.apps.googleusercontent.com"
              // appId="903778737118-bs5n5qp7g11vd4fu4mbuotodha79scbc.apps.googleusercontent.com"
              appId={Constants.GOOGLE_LOGIN_CLIENT_ID}
              //appId="903778737118-u00cqf8bfjc1s2ido8mbqoinj3jgt62p.apps.googleusercontent.com"
              onLoginSuccess={this.handleGoogleLogin}
              onLoginFailure={this.handleGoogleLoginFailure}
            >
             
              <img
                className="socialIcon"
                alt="Login with google"
                src={"../../images/login/google.svg"}
              />
              <span>Google</span>
            </SocialButton>
      </div>

    </Modal>
    )
    }
   
  }

export default withRouter(ModalBox);